import { CHARACTER_SEPARATOR_IOT_KEY_NAME } from '../../components/CycleChartPreview/constants';
import { IChannelName } from '../../types/channel-types';

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const checkChannelController = (channelId: string, controllerSerialNumber: string) => {
  return channelId.split(CHARACTER_SEPARATOR_IOT_KEY_NAME)[0] === controllerSerialNumber;
};

export const getChannelNames = (
  availableChannels: string[],
  channelsList: Record<string, IChannelName[]>,
  controllerSerialNumber: string,
): string[] => {
  const channels = channelsList[controllerSerialNumber] || [];
  return availableChannels.map((channel) => {
    const finedChannel: IChannelName | undefined = channels.find(
      (channelState) =>
        channel === channelState.channel &&
        checkChannelController(channelState.id, controllerSerialNumber) &&
        Boolean(channelState.name?.trim().length),
    );

    return finedChannel?.name?.trim() || channel;
  });
};
